// Dependencias generales
import React from "react";

// Función del router
const Loader = (params) => {

  return (           

    [ params.initialStatus === undefined ?
      <div key={params.Id} id={params.Id} className="loader hidden">
        <progress aria-label={params.Mensaje} style={{display: 'block', position: 'relative', margin: 'auto'}}></progress>
        <label id={params.Id+"Label"} style={{position: 'absolute', textAlign: 'center', marginTop: '100px'}}>{params.Mensaje}</label>      
      </div>
    :
      <div key={params.Id} id={params.Id} className={"loader "+params.initialStatus}>
        <progress aria-label={params.Mensaje} style={{display: 'block', position: 'relative', margin: 'auto'}}></progress>
        <label id={params.Id+"Label"} style={{position: 'absolute', textAlign: 'center', marginTop: '100px'}}>{params.Mensaje}</label>      
      </div>
    ]
    
  )

}

export default Loader